import * as PropTypes from "prop-types";
import SaveSnapshotModal from "layout/discovery/modals/SaveSnapshotModal";
import AddUserModal from "layout/systemAdmin/workspaces/modals/AddUserModal";
import DeleteWorkspaceModal from "layout/systemAdmin/workspaces/modals/DeleteWorkspaceModal";
import ReserveLicensesModal from "layout/systemAdmin/workspaces/modals/ReserveLicensesModal";
import AnonymiseUsersModal from "layout/systemAdmin/workspaces/modals/AnonymiseUsersModal";
import EditUserPermissionsModal from "layout/systemAdmin/workspaces/modals/EditUserPermissionsModal";
import newUserModal from "layout/systemAdmin/users/modals/NewUserModal";
import editUserModal from "layout/systemAdmin/users/modals/EditUserModal";
import ExportReportModal from "layout/systemAdmin/workspaces/modals/ExportReportModal";
import ImportUsersModal from "layout/systemAdmin/users/modals/ImportUsersModal";
import EditUserAndPermissionsModal from "layout/userAdmin/users/modals/EditUserAndPermissionsModal";
import DetailsModal from "layout/dictionary/modals/DetailsModal";
import EnableSsoModal from "layout/systemAdmin/authentication/modals/EnableSsoModal";
import EnableUserPasswordModal from "layout/systemAdmin/authentication/modals/EnableUsernamePasswordModal";
import AboutVtDocsModal from "layout/dashboard/modals/AboutVtDocsModal";
import ChangePasswordModal from "layout/dashboard/modals/ChangePasswordModal";
import TextFieldModal from "components/Modal/TextFieldModal";
import ImportFileModal from "components/Modal/ImportFileModal";
import ConfirmationModal from "components/Modal/ConfirmationModal";
import ErrorModal from "components/Modal/ErrorModal";
import ChangeDictionaryModal from "layout/dictionarySearch/modals/ChangeDictionaryModal";
import DictionarySearchExportMultipleDocumentsModal from "layout/dictionarySearch/modals/ExportMultipleDocumentsModal";
import DiscoveryExportMultipleDocumentsModal from "layout/discovery/modals/ExportMultipleDocumentsModal";
import ExportContentModalXlsx from "layout/dictionarySearch/modals/ExportContentModalXlsx";
import BannerModal from "layout/systemAdmin/workspaces/modals/BannerModal";
import ImportDictionaryModal from "layout/dictionarySearch/modals/ImportDictionaryModal";
import AnnotatedDocumentModal from "layout/dictionarySearch/modals/AnnotatedDocumentModal";
import IgnoreTermConfirm from "layout/discovery/modals/IgnoreTermConfirm";
import ShredToExcelModal from "layout/discovery/modals/ShredToExcelModal";
import ResetDefaultsModal from "layout/settings/readabilityThresholds/ResetDefaultsModal";
import CreateNewDictionaryModal from "layout/discovery/modals/CreateNewDictionaryModal";
import CreateNewCategoryModal from "layout/discovery/modals/CreateNewCategoryModal";
import SelectDocumentModal from "layout/discovery/modals/SelectDocumentModal";

const MODAL_COMPONENTS = {
  SAVE_SNAPSHOT: SaveSnapshotModal,
  CONFIRMATION: ConfirmationModal,
  ADD_USER_TO_WORKSPACE: AddUserModal,
  ERROR: ErrorModal,
  DELETE_WORKSPACE: DeleteWorkspaceModal,
  WORKSPACE_RESERVED_LICENSES: ReserveLicensesModal,
  ANONYMIZE_USERS: AnonymiseUsersModal,
  WORKSPACE_BANNER: BannerModal,
  EDIT_PERMISSIONS: EditUserPermissionsModal,
  EXPORT_REPORT: ExportReportModal,
  NEW_USER: newUserModal,
  EDIT_USER: editUserModal,
  IMPORT_USERS: ImportUsersModal,
  EDIT_USER_AND_PERMISSIONS: EditUserAndPermissionsModal,
  DICTIONARY_FOLDER_DOC_INFO: DetailsModal,
  ENABLE_SSO: EnableSsoModal,
  ENABLE_USERNAME_PASSWORD: EnableUserPasswordModal,
  ABOUT_VT_DOCS: AboutVtDocsModal,
  CHANGE_PASSWORD: ChangePasswordModal,
  IMPORT_FILE: ImportFileModal,
  TEXT_FIELD_MODAL: TextFieldModal,
  CHANGE_DICTIONARY: ChangeDictionaryModal,
  EXPORT_MULTIPLE_DOCS: DictionarySearchExportMultipleDocumentsModal,
  EXPORT_CONTENT: ExportContentModalXlsx,
  IMPORT_DICTIONARY: ImportDictionaryModal,
  ANNOTATED_DOCUMENT: AnnotatedDocumentModal,
  SHRED_TO_EXCEL: ShredToExcelModal,
  DISCOVERY_EXPORT_MULTIPLE_DOCS: DiscoveryExportMultipleDocumentsModal,
  RESET_DEFAULTS_THRESHOLDS: ResetDefaultsModal,
  IGNORE_TERM_CONFIRM: IgnoreTermConfirm,
  CREATE_NEW_DICTIONARY: CreateNewDictionaryModal,
  CREATE_NEW_CATEGORY: CreateNewCategoryModal,
  SELECT_DOCUMENT: SelectDocumentModal,
};

const ModalRoot = ({ modalType, modalProps }) => {
  if (!modalType) {
    return null;
  }

  const SpecificModal = MODAL_COMPONENTS[modalType];
  // The modalProps can be a list of anything so this has to be spread
  return <SpecificModal {...modalProps} />;
};

export default ModalRoot;

ModalRoot.propTypes = {
  modalType: PropTypes.string,
  // The modalProps can be a list of anything so this has to be an object with not types
  // eslint-disable-next-line react/forbid-prop-types
  modalProps: PropTypes.object,
};
